import { ILoginSuccess } from "../interfaces/auth";
import { forEach } from "lodash";

export const setSessionLocalStorage = (object: ILoginSuccess) => {
  forEach(object, (value, key) => {
    if (value) {
      localStorage.setItem(key, value);
    }
  });
};

export const unsetSessionLocalStorage = () => {
  localStorage.clear();
};
